export default {"src":"/_next/static/media/Bone-and-Soft-Tissue-Sarcomas.f63ed52a.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};